var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 11V5.00002C14.6001 4.17154 13.9595 3.5 13.1693 3.5H5.89252C5.51307 3.5 5.14907 3.65805 4.88076 3.93934L2.01918 6.93938C1.4604 7.52508 1.4604 8.47492 2.01918 9.06069L4.88076 12.0607C5.14907 12.3419 5.51307 12.5 5.89252 12.5H13.1693C13.9595 12.5 14.6001 11.8285 14.6001 11Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5C7.32845 6.5 8 7.16563 8 8C8 8.82845 7.33437 9.5 6.5 9.5C5.67155 9.5 5 8.83437 5 8C5 7.17155 5.66563 6.5 6.5 6.5Z",
    fill: "currentFill",
    stroke: "none",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconNew);
export default __webpack_public_path__ + "static/media/TagIconNew.3ee307d908f6726e7e26e47f5c67578f.svg";
export { ForwardRef as ReactComponent };